import React from "react";
import StaticLayout from "../../layouts/static-layout";
import PayHome from "../../views/pay/pay-home";

export default function PayPage() {
  return (
    <StaticLayout>
      <PayHome />
    </StaticLayout>
  );
}
